// Disparo de conversiones de Google Ads en el cliente.
// Seguro: si faltan las variables de entorno o gtag no está cargado, no hace nada.

const ADS_CONVERSION_ID = import.meta.env.VITE_GOOGLE_ADS_CONVERSION_ID as string | undefined;
const REGISTRO_LABEL = import.meta.env
  .VITE_GOOGLE_ADS_REGISTRO_CONVERSION_LABEL as string | undefined;

/**
 * Dispara la conversión "Registro completado" de Google Ads, una sola vez por `dedupeKey`
 * (email o id de usuario). No-op si faltan credenciales o gtag.
 */
export function fireRegistroConversion(dedupeKey: string) {
  if (!ADS_CONVERSION_ID || !REGISTRO_LABEL) return;
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;

  const storageKey = `google_ads_registro_conversion_${dedupeKey}`;
  try {
    if (window.localStorage.getItem(storageKey) === "sent") return;
  } catch {
    // localStorage puede no estar disponible; igual disparamos una vez.
  }

  window.gtag("event", "conversion", {
    send_to: `${ADS_CONVERSION_ID}/${REGISTRO_LABEL}`,
  });

  try {
    window.localStorage.setItem(storageKey, "sent");
  } catch {
    // ignore
  }
}
